import Relogio from "./Relogio";
import Letreiro from "./Letreiro";
import BtnVoltar from "../components/BtnVoltar";

export default function Atv01() {
    return(
        <>
            <h1>Atividades da Semana 1</h1>
            <Relogio />
            <Letreiro />
            <BtnVoltar />
        </>
    );
}